/**
 * Canales de audio del motor.
 *
 * Están separados porque una persona puede necesitar bajar la música y el
 * ambiente para oír mejor su lector de pantalla sin perder los efectos que
 * llevan información. El volumen de cada canal es independiente y `master`
 * multiplica a todos.
 */
export const AUDIO_CHANNELS = ['master', 'music', 'ambient', 'effects', 'voice'] as const;

export type AudioChannel = (typeof AUDIO_CHANNELS)[number];

/** Canales que reproducen contenido, sin contar el maestro. */
export type PlayableChannel = Exclude<AudioChannel, 'master'>;

export type ChannelVolumes = Record<AudioChannel, number>;

export const defaultVolumes: ChannelVolumes = {
  master: 0.8,
  music: 0.5,
  ambient: 0.5,
  effects: 0.9,
  voice: 1,
};

export function clampVolume(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.min(1, Math.max(0, value));
}

/** Volumen real de una pista: el del canal atenuado por el maestro. */
export function effectiveVolume(volumes: ChannelVolumes, channel: PlayableChannel): number {
  return clampVolume(volumes[channel]) * clampVolume(volumes.master);
}
